import isAbandonedCartRoute from './isAbandonedCartRoute';

export default isAbandonedCartRoute;
